{
  "updateAvailable": "نسخه جدیدی از برنامه در دسترس است. آیا مایل به بارگذاری مجدد هستید؟",
  "updateTitle": "به‌روزرسانی جدید",
  "updateButton": "به روزرسانی",
  "mainPage": "صفحه اصلی",
  "home": "خانه",
  "print": "چاپ",
  "buyer": "خریدار",
  "seller": "فروشنده",
  "submit": "ارسال",
  "search": "جستجو",
  "newReq": "درخواست جدید",
  "detail": "جزئیات",
  "confirm": "تایید",
  "dragAndDrop": "برای آپلود، فایل ها را بکشید و اینجا رها کنید",
  "ton": "تن",
  "current": "مرحله کنونی",
  "next": "مرحله بعد",
  "accepted": "پذیرفته شده",
  "pending": "در انتظار",
  "complete": "تکمیل",
  "view": "مشاهده",
  "unknown": "نامشخص",
  "section": "بخش",
  "type": "نوع",
  "acceptanceDate": "تاریخ پذیرش",
  "ipAddress": "آدرس IP",
  "simpleAcceptance": "پذیرش ساده",
  "signatureRequired": "نیاز به امضا",
  "errorLoadingData": "خطا در بارگذاری داده‌ها",
  "SIDEBAR": {
    "spaceType": "مدیریت نوع فضا",
    "speciality": "مدیریت تخصص",
    "facility": "مدیریت تسهیلات و امکانات",
    "neighborhood": "مدیریت محله‌ها",
    "approvalWaitList": "مدیریت درخواست تغییر کاربری",
    "adTitle": "ثبت آگهی",
    "acceptAd": "صدور مجوز آگهی ها",
    "adsList": "لیست آگهی ها",
    "roleMake": "احراز هویت و انتخاب نقش",
    "myAds": "آگهی های من",
    "chat": "پیام‌ها",
    "bannerManagement": "مدیریت بنر‌های تبلیغاتی",
    "promotionManagement": "مدیریت ارتقای آگهی",
    "setting": "تنظیمات",
    "profile": "پروفایل",
    "userManagement": "مدیریت کاربران ",
    "report": "گزارشات",
    "elasticManagement": "مدیریت الستیک سرچ"
  },
  "elasticManagement": {
    "syncTitle": "همگام‌سازی داده‌ها",
    "syncDesc": "بازنویسی تمام آگهی‌های منتشر شده در ایندکس الستیک سرچ",
    "syncBtn": "شروع همگام‌سازی",
    "syncSuccess": "همگام‌سازی با موفقیت آغاز شد",
    "syncError": "خطا در همگام‌سازی",
    "deleteTitle": "حذف ایندکس",
    "deleteDesc": "پاک کردن کامل تمام داده‌های ایندکس الستیک سرچ",
    "deleteBtn": "حذف ایندکس",
    "deleteSuccess": "ایندکس با موفقیت پاک شد",
    "deleteError": "خطا در حذف ایندکس",
    "confirmMsg": "آیا از حذف کل ایندکس الستیک سرچ اطمینان دارید؟",
    "confirmHeader": "تایید حذف",
    "confirmAccept": "بله، حذف شود",
    "confirmReject": "انصراف"
  },
  "spaceType": {
    "title": "نوع فضا",
    "loading": "در حال بارگذاری...",
    "empty": "هیچ فضایی ثبت نشده !",
    "search": "جستجوی نام فضا...",
    "form": {
      "new": "ایجاد نوع فضا",
      "edit": "ویرایش نوع فضا",
      "name": "نام فضا"
    },
    "validation": {
      "nameRequired": "نام فضا را وارد کنید"
    },
    "table": {
      "title": "عنوان",
      "sectionKey": "کلید بخش",
      "agreementType": "نوع قرارداد",
      "active": "فعال",
      "actions": "عملیات"
    }
  },
  "speciality": {
    "title": "تخصص",
    "loading": "در حال بارگذاری...",
    "empty": "هیچ تخصصی ثبت نشده !",
    "search": "جستجوی نام تخصص...",
    "form": {
      "new": "ایجاد تخصص",
      "edit": "ویرایش تخصص",
      "name": "نام تخصص"
    },
    "validation": {
      "nameRequired": "نام تخصص را وارد کنید"
    },
    "table": {
      "title": "عنوان",
      "sectionKey": "کلید بخش",
      "agreementType": "نوع قرارداد",
      "active": "فعال",
      "actions": "عملیات"
    }
  },
  "facility": {
    "title": "تسهیلات و امکانات",
    "loading": "در حال بارگذاری...",
    "empty": "هیچ تسهیلات یا امکانات ثبت نشده !",
    "search": "جستجوی نام تسهیلات...",
    "form": {
      "new": "ایجاد تسهیلات / امکانات",
      "edit": "ویرایش تسهیلات / امکانات",
      "name": "نام تسهیلات / امکانات"
    },
    "validation": {
      "nameRequired": "نام تسهیلات / امکانات را وارد کنید"
    },
    "table": {
      "title": "عنوان",
      "sectionKey": "کلید بخش",
      "agreementType": "نوع قرارداد",
      "active": "فعال",
      "actions": "عملیات"
    }
  },
  "approval-wait-list": {
    "title": "مدیریت درخواست تغییر نقش",
    "loading": "در حال بارگذاری...",
    "empty": "هیچ درخواستی وجود ندارد !",
    "messages": {
      "loadError": "خطا در بارگذاری اطلاعات"
    },
    "form": {
      "name": "نام کاربر",
      "role": "نقش درخواستی"
    },
    "filters": {
      "status": "وضعیت",
      "role": "نقش"
    },
    "table": {
      "status": "وضعیت",
      "date": "تاریخ",
      "actions": "عملیات"
    },
    "details": {
      "title": "جزئیات درخواست",
      "feedback": "توضیحات مدیر",
      "files": "مدارک پیوست",
      "document": "مدرك هویتی",
      "certificate": "گواهی",
      "license": "مجوز / پروانه",
      "feedbackPlaceholder": "در صورت نیاز، توضیحات برای کاربر وارد کنید...",
      "notReviewable": "این درخواست در وضعیت قابل بررسی نیست",
      "confirmApprove": "آیا از تأیید و اختصاص این نقش به کاربر مطمئن هستید؟"
    },
    "actions": {
      "startReview": "شروع بررسی",
      "requestEdit": "درخواست اصلاح",
      "reject": "رد",
      "approve": "تأیید"
    },
    "statuses": {
      "draft": "پیش‌نویس",
      "submitted": "ارسال شده",
      "under_review": "در حال بررسی",
      "needs_edit": "نیازمند اصلاح",
      "approved": "تأیید شده",
      "rejected": "رد شده"
    },
    "roles": {
      "clinic_admin": "مدیر کلینیک",
      "salon_admin": "مدیر سالن",
      "trainer_user": "مدرس",
      "trainee_user": "هنرجو/بیوتی‌آرتیست",
      "seller_user": "فروشنده"
    },
    "validation": {
      "feedbackRequired": "برای این عملیات، توضیحات الزامی است."
    }
  },
  "requestRole": {
    "title": "تکمیل احراز هویت و انتخاب نقش",
    "subtitle": "نقش موردنظر خود را انتخاب کنید و مدارک لازم را بارگذاری نمایید.",
    "selectRole": "انتخاب نقش",
    "documents": "مدارک و مستندات",
    "documentsHint": "هر سه فایل (مدرك، گواهی، مجوز) برای ارسال نهایی الزامی است.",
    "adminNote": "توضیحات مدیر",
    "needsEditTitle": "درخواست شما نیاز به اصلاح دارد",
    "needsEditHint": "لطفاً موارد ذکر‌شده را اصلاح کرده و مجدداً ارسال کنید. تغییر نقش در این مرحله امکان‌پذیر نیست.",
    "roleLocked": "نقش در این مرحله قابل تغییر نیست.",
    "upload": "بارگذاری",
    "uploaded": "بارگذاری شد",
    "saveDraft": "ذخیره پیش‌نویس",
    "submit": "ارسال برای بررسی",
    "edit": "ویرایش",
    "noIdentity": "لطفاً ابتدا اطلاعات هویتی خود را تکمیل کنید.",
    "goToProfile": "تکمیل اطلاعات",
    "myRequests": "درخواست‌های من",
    "requiredDocs": "مدارک مورد نیاز",
    "activeAccesses": "دسترسی‌های فعال پس از تأیید",
    "uploadWarning": "برای ارسال درخواست بررسی، بارگذاری تمام مدارک الزامی است. در صورت ناقص بودن مدارک، امکان ارسال درخواست وجود ندارد.",
    "noDocsRequired": "مدرک الزامی نیست",
    "noAvailableRoles": "شما در حال حاضر برای همه نقش‌ها درخواست فعال دارید یا نقش‌های موجود را دارید.",
    "selectSubType": "نوع ثبت‌نام‌کننده",
    "additionalInfo": "اطلاعات تکمیلی",
    "files": {
      "nationalId": "بارگذاری کارت ملی",
      "spaceSignPhoto": "بارگذاری عکس مجوز کسب و کار",
      "spaceImages": "بارگذاری تصاویر مدارک",
      "businessLicense": "بارگذاری جواز کسب",
      "clinicLicense": "بارگذاری مجوز کلینیک",
      "medicalCertificate": "بارگذاری گواهی نظام پزشکی",
      "resume": "بارگذاری مدرک مجوز آموزشگاه",
      "courseSyllabus": "بارگذاری مدرک فنی وحرفه ای",
      "schoolLicense": "بارگذاری مجوز مدرسه یا مؤسسه",
      "ownershipProof": "بارگذاری فاکتور یا سند مالکیت کالا",
      "healthCertificate": "بارگذاری گواهی بهداشت یا اصالت کالا",
      "productImages": "بارگذاری تصاویر واقعی محصول",
      "realEstateLicense": "بارگذاری پروانه یا مجوز املاک",
      "publicationPermit": "بارگذاری مجوز انتشار آگهی"
    },
    "statuses": {
      "draft": "در انتظار تکمیل مدارک",
      "submitted": "در انتظار بررسی",
      "under_review": "در حال بررسی",
      "needs_edit": "نیازمند اصلاح",
      "approved": "تأیید شده",
      "rejected": "رد شده"
    },
    "roles": {
      "user": "کاربر عادی",
      "beauty_artist": "بیوتی آرتیست / هنرجو",
      "salon_admin": "مدیر سالن / مالک فضا",
      "clinic_admin": "پزشک / مدیر کلینیک",
      "instructor": "مدرس / آموزشگاه",
      "trainer_user": "مدرس / آموزشگاه",
      "trainee_user": "هنرمند زیبایی / هنرجو",
      "seller_user": "فروشنده تجهیزات یا مواد زیبایی"
    },
    "subTypes": {
      "salonOwner": "مدیر سالن / مالک فضا",
      "realEstateExpert": "مشاور املاک",
      "student": "هنرجو/بیوتی‌آرتیست",
      "artist": "هنرمند زیبایی",
      "teacher": "مدرس",
      "school": "آموزشگاه",
      "doctor": "پزشک",
      "clinicManager": "مدیر کلینیک",
      "equipment": "تجهیزات",
      "material": "مواد مصرفی"
    },
    "textFields": {
      "lineOfWork": "حوزه تخصصی / رشته فعالیت",
      "medicalSystemNumber": "شماره نظام پزشکی",
      "officeAddress": "آدرس محل کسب",
      "officeContactNumber": "شماره تماس محل کسب",
      "productInfo": "اطلاعات محصول (سریال، گارانتی، تاریخ تولید و انقضا)"
    },
    "accesses": {
      "user": {
        "viewAds": "مشاهده آگهی‌ها",
        "searchFilter": "جستجو، فیلتر و مقایسه",
        "compare": "مقایسه آگهی‌ها",
        "saveInterests": "ذخیره علاقه‌مندی‌ها",
        "viewCoursesProfiles": "مشاهده دوره‌ها و پروفایل‌ها",
        "viewContactInfo": "مشاهده اطلاعات تماس آگهی‌دهنده",
        "contactAdvertiser": "تماس با آگهی‌دهنده و ارسال پیام"
      },
      "salonAdmin": {
        "registerSpaceAds": "ثبت آگهی اجاره فضا (صندلی، اتاق، تخت، میز، فضای کار، سالن کامل، کلینیک)",
        "manageAds": "مدیریت، ویرایش، حذف، تمدید، نردبان، فوری و ویژه آگهی‌ها",
        "viewMessages": "مشاهده پیام‌ها",
        "viewStats": "مشاهده آمار بازدید",
        "contact": "ارتباط و ذخیره",
        "payments": "پرداخت‌ها"
      },
      "traineeUser": {
        "viewCompareAds": "مشاهده و مقایسه آگهی‌ها",
        "viewContactInfo": "مشاهده اطلاعات تماس",
        "sendMessages": "ارسال پیام",
        "viewCourses": "مشاهده دوره‌ها",
        "registerCompanion": "ثبت درخواست همراه",
        "registerRentalAd": "ثبت آگهی اجاره یا همراه",
        "sellPersonalEquipment": "فروش تجهیزات شخصی یا دست دوم",
        "registerAuction": "ثبت آگهی حراج تجهیزات شخصی",
        "manageAds": "مدیریت آگهی‌های خود",
        "purchaseServices": "خرید نردبان / فوری / ویژه"
      },
      "trainerUser": {
        "registerCourses": "ثبت دوره حضوری، آنلاین یا ترکیبی",
        "manageCourses": "مدیریت، ویرایش، حذف و تمدید دوره",
        "viewStudentMessages": "مشاهده پیام‌ها و درخواست‌های هنرجویان/بیوتی‌آرتیست‌ها",
        "viewStats": "مشاهده آمار بازدید و ثبت‌نام",
        "purchaseServices": "خرید تبلیغات، نردبان، فوری و ویژه"
      },
      "clinicAdmin": {
        "registerSpaceAds": "ثبت آگهی فضای بالینی",
        "registerCooperationAds": "ثبت آگهی همکاری تخصصی",
        "introduceServices": "معرفی خدمات قابل نمایش",
        "manageAds": "مدیریت آگهی‌ها",
        "receiveMessages": "دریافت پیام",
        "viewStats": "مشاهده آمار",
        "purchasePromotions": "خرید خدمات ارتقای آگهی",
        "registerCourses": "ثبت دوره تخصصی یا رویداد (در صورت احراز نقش مدرس)"
      },
      "sellerUser": {
        "registerEquipmentAds": "ثبت آگهی فروش تجهیزات نو و دست دوم",
        "registerMaterialAds": "ثبت آگهی فروش مواد مصرفی",
        "registerAuctionAds": "ثبت آگهی حراج تجهیزات (در صورت فعال بودن حراج)",
        "manageAds": "مدیریت آگهی‌ها",
        "receiveMessages": "دریافت پیام",
        "viewStats": "مشاهده آمار",
        "purchaseServices": "خرید نردبان / فوری / ویژه"
      }
    },
    "draftSaved": "پیش‌نویس ذخیره شد.",
    "submitSuccess": "درخواست شما با موفقیت ارسال شد و پس از احراز هویت و بررسی تیم Beauty Boss نتیجه اعلام خواهد شد.",
    "saveError": "خطا در ذخیره درخواست.",
    "uploadError": "خطا در بارگذاری فایل.",
    "shahkarFailed": "احراز هویت کد ملی ناموفق بود. لطفاً کد ملی و شماره موبایل خود را در پروفایل بررسی کنید."
  },
  "actions": {
    "save": "ذخیره",
    "cancel": "انصراف",
    "later": "بعدا"
  },
  "agreement": {
    "details": {
      "title": "توافقنامه",
      "status": "وضعیت"
    }
  },
  "report": {
    "moneyWallet": "گزارشات مالی",
    "orders": "گزارشات سفارشات",
    "trade": "گزارشات معاملات",
    "debtorCreditorDetails": "جزئیات",
    "realTradeAmount": "هزینه معامله - کارمزد و ارزش افزوده",
    "realTradeAmountForSeller": "هزینه معامله + کارمزد و ارزش افزوده",
    "fees": "کارمزد",
    "vat": "ارزش افزوده"
  },
  "DASHBOARD": {
    "STOCKS_TITLE": "سهام‌ها",
    "PORTFOLIO_TITLE": "سبد دارایی",
    "CASH_BALANCE": "موجودی نقدی:"
  },
  "TABLE": {
    "SYMBOL": "نماد",
    "COMPANY": "نام شرکت",
    "PRICE": "قیمت",
    "CHANGE": "تغییر",
    "VOLUME": "حجم",
    "SHARES": "تعداد",
    "AVG_BUY": "میانگین خرید"
  },
  "PORTFOLIO": {
    "TITLE": "پرتفوی",
    "TOTAL_VALUE": "ارزش کل پرتفوی",
    "basedOnLastTradePrice": "طبق آخرین قیمت معامله",
    "HOLDINGS": "دارایی‌ها",
    "SYMBOL": "نماد",
    "QTY": "تعداد",
    "CURRENT_PRICE": "قیمت فعلی(﷼)",
    "VALUE": "ارزش کل(﷼)",
    "PNL": "سود/زیان(﷼)",
    "CURRENCY": "ريال",
    "AVG_BUY_PRICE": "قیمت متوسط(﷼)",
    "NEW": "جدید",
    "SINCE_LAST_VISIT": "از آخرین بازدید",
    "CARD_2_TITLE": "موجودی من",
    "CARD_3_TITLE": "موجودی بلوکه‌شده",
    "CARD_4_TITLE": "موجودی در انتظار تایید",
    "showOldStockWallet": "نمایش دارایی‌های قدیمی",
    "empty": "سبد دارایی شما خالی است"
  },
  "LAB_ANALYSIS": {
    "ID": "شناسه",
    "BUNDLE_CODE": "کد بسته",
    "LABORATORY_NAME": "نام آزمایشگاه",
    "ANALYSIS_TYPE": "نوع آزمایش",
    "STATUS": "وضعیت",
    "RESULT": "نتیجه",
    "CREATED_AT": "تاریخ ایجاد",
    "UPDATED_AT": "تاریخ بروزرسانی"
  },
  "TRADE": {
    "TITLE": "معاملات",
    "BALANCE": "موجودی",
    "POSITIONS": "موقعیت‌های شما",
    "SYMBOL": "نماد",
    "QUANTITY": "تعداد",
    "AVG_PRICE": "میانگین قیمت",
    "NEW_ORDER": "ثبت سفارش جدید",
    "BUY": "خرید",
    "SELL": "فروش",
    "QTY": "تعداد",
    "LIMIT_PRICE": "قیمت محدود",
    "PLACE_ORDER": "ارسال",
    "ORDERS": "تاریخچه سفارشات",
    "ID": "شناسه",
    "SIDE": "نوع سفارش",
    "PRICE": "قیمت",
    "STATUS": "وضعیت",
    "TIME": "زمان",
    "FILLED": "انجام شده",
    "OPEN": "باز",
    "CANCELLED": "لغو شده",
    "DIRECTION": "{{dir}}",
    "PARTIALLY_FILLED": "انجام ناقص"
  },
  "profile": {
    "title": "پروفایل کاربر",
    "firstName": "نام",
    "lastName": "نام خانوادگی",
    "email": "ایمیل",
    "phone": "شماره تماس",
    "language": "زبان",
    "save": "ذخیره تغییرات",
    "changeAvatar": "تغییر تصویر",
    "currentPassword": "رمز عبور فعلی",
    "newPassword": "رمز عبور جدید",
    "confirmPassword": "تأیید رمز عبور",
    "changePasswordBtn": "تغییر رمز عبور",
    "required": "این فیلد الزامی است",
    "passwordMinLength": "رمز عبور باید حداقل ۶ کاراکتر باشد",
    "passwordMismatch": "رمزهای عبور مطابقت ندارند",
    "infoTab": "اطلاعات کاربری",
    "activeSessions": "نشست های فعال",
    "passwordTab": "تغییر رمز عبور",
    "defaultReferral": "کد دعوت ییش‌فرض",
    "shareReferralLink": "اشتراک گذاری لینک دعوت",
    "copy": "کپی کردن",
    "registerInvitationCode": "ثبت کد دعوت",
    "invitationCode": "کد دعوت را وارد کنید",
    "sending": "درحال ارسال",
    "alreadyRegistered": "شما قبلا ثبت نام کرده‌اید.",
    "benefitTitle": "شما قبلا ثبت نام کرده‌اید.",
    "getRewardTitle": "چطور پاداش دریافت کنید",
    "invited": "دعوت شده‌ها",
    "shareText": "سلام! خوبی؟ حتما با این لینک تو سایتش ثبت‌نام کن‌، یه سامانه عالی و مطمئنه برای خرید و فروش فلزات غیررنگین:",
    "tabs": {
      "info": "اطلاعات کاربری",
      "password": "تغییر رمز عبور",
      "activeSessions": "جلسات فعال",
      "referral": "کد دعوت"
    },
    "form": {
      "changeAvatar": "تغییر آواتار",
      "username": "نام کاربری",
      "email": "ایمیل",
      "firstName": "نام",
      "lastName": "نام خانوادگی",
      "identity": "کد ملی",
      "identityRequired": "کد ملی الزامی است.",
      "phoneNumber": "شماره تلفن",
      "edit": "ویرایش"
    },
    "phoneDialog": {
      "title": "تایید شماره تلفن",
      "enterNewPhone": "شماره همراه جدید خود را وارد کنید.",
      "send": "ارسال",
      "resend": "ارسال مجدد کد تایید! ",
      "enterOTP": "کد ارسال شده را وارد کنید.",
      "confirm": "تایید"
    },
    "common": {
      "acceptanceDate": "تاریخ پذیرش",
      "ipAddress": "آدرس آی‌پی",
      "complete": "امضا شده",
      "view": "نمایش",
      "confirmDelete": "آیا از حذف اطمینان دارید؟",
      "confirm": "تایید",
      "cancel": "انصراف"
    },
    "termsAndAgreements": "شرایط و توافقنامه‌ها",
    "terms": "قراردادها",
    "agreements": "توافقنامه‌ها",
    "noAgreementsFound": "هیچ توافقنامه‌ای یافت نشد"
  },
  "order": {
    "title": "سفارش‌های من",
    "newOrder": "سفارش جدید",
    "loading": "در حال بارگیری سفارش‌ها...",
    "error": "خطا در بارگیری سفارش‌ها",
    "id": "شماره سفارش",
    "date": "تاریخ",
    "statusHeader": "وضعیت",
    "total": "مبلغ کل(﷼)",
    "empty": "هنوز سفارشی ثبت نکرده‌اید",
    "selectedItemsLabel": " نوع وضعیت انتخاب شده",
    "selectedOrdersTypeLabel": " نوع سفارش انتخاب شده",
    "fee": "حداکثر کارمزد",
    "vat": "ارزش افزوده",
    "priceWithFee": "مبلغ‌کل با احتساب کارمزد و ارزش افزوده",
    "amountYouWillReceive": "میلغ‌کل دریافتی با احتساب کارمزد",
    "statusMap": {
      "pending": "در انتظار",
      "shipped": "ارسال شده",
      "delivered": "تحویل شده",
      "cancelled": "لغو شده",
      "NEW": "در صف انجام",
      "PARTIALLY_FILLED": "در حال انجام",
      "CANCELED": "لغو شده",
      "CANCELED_SELF_TRADE": "رد سفارش(selfTrade)",
      "FILLED": "تکمیل شده",
      "REJECTED": "رد شده",
      "EXPIRED": "منقضی شده",
      "PARTIALLY_CANCELED": "لغو شده(قسمتی انجام شده)",
      "CANCELED_INSUFFICIENT_FUNDS": "لغو شد (موجودی ناکافی)"
    },
    "header": {
      "index": "ردیف",
      "orderType": "سفارش",
      "symbol": "نماد",
      "date": "زمان",
      "status": "وضعیت",
      "orderPrice": "قیمت سفارش(﷼)",
      "price": "قیمت میانگین معامله(﷼)",
      "total": "مبلغ(﷼)",
      "quantity": "تعداد",
      "fill_quantity": "مقدار پرشده",
      "orderer": "سفارش دهنده"
    },
    "action": {
      "delete": "لغو",
      "deleteConfirmMsg": "آیا از لغو سفارش خود اطمینان دارید؟",
      "confirm": "تایید",
      "cancel": "انصراف"
    },
    "confirmOrder": {
      "header": "تایید سفارش",
      "content": "آیا از اطلاعات سفارش خود مطمئن هستید؟",
      "marketOrderWarning": "توجه: طبق قرارداد فلان (هنوز توسط برنامه‌نویسان پیاده سازی نشده و در هنگام ورود به سایت بیانیه توسط کاربر امضا خواهد شد) در سفارش سریع (Market)، معامله شما ممکن است با هر قیمتی که در صف سفارشات موجود باشد، انجام شود.و تمام مسئولیت سفارش با شماست.(این متن تستی است و بعد از هماهنگی ها ویرایش میشود)",
      "confirm": "تایید و ارسال سفارش",
      "cancel": "لغو"
    }
  },
  "orderBook": {
    "count": "تعداد",
    "quantity": "حجم",
    "price": "قیمت",
    "labelBuy": "سفارشات خرید",
    "labelSell": "سفارشات فروش",
    "totalQuantity": "حجم کل",
    "buyTotalQuantity": "حجم خرید",
    "sellTotalQuantity": "حجم فروش",
    "selectPrice": "برای انتخاب قیمت کلیک کنید"
  },
  "goodsCategory": {
    "title": "دسته‌بندی و زیرمجموعه کالاها",
    "addNewCategory": "افزودن دسته جدید",
    "name": "نام",
    "actions": "عملیات",
    "edit": "ویرایش",
    "delete": "حذف",
    "addSub": "افزودن زیرمجموعه",
    "addCategory": "افزودن دسته",
    "cancel": "انصراف",
    "save": "ذخیره",
    "subCategoryDetails": "جزئیات زیرمجموعه"
  },
  "goodsToWarehousing": {
    "title": "پیکربندی قیمت کالا در انبار",
    "addConfig": "افزودن پیکربندی جدید",
    "stockSymbol": "نماد کالا",
    "price": "قیمت",
    "startDate": "تاریخ شروع",
    "endDate": "تاریخ پایان",
    "isActive": "فعال است",
    "action": "عملیات",
    "edit": "ویرایش",
    "delete": "حذف",
    "addConfigTitle": "افزودن پیکربندی قیمت کالا در انبار",
    "stockSymbolName": "نام نماد کالا (نوع کالا)",
    "priceLabel": "قیمت",
    "isConfigActive": "آیا پیکربندی فعال است؟",
    "cancel": "انصراف",
    "save": "ذخیره",
    "validation": {
      "quantityRequired": "مقدار الزامی است",
      "quantityMin": "حداقل باید ۱ باشد"
    }
  },
  "labAnalysis": {
    "owner": "مالک",
    "trackingNumber": "کد پیگیری",
    "weightStatus": "وزن‌کشی",
    "bundleWeight": "وزن باندل",
    "bundleLabel": "برچسب باندل",
    "warehouseUnitTitle": "یونیت",
    "converted": "توکنایز شده",
    "not_converted": "توکنایز نشده",
    "title": "پیکربندی آنالیز آزمایشگاه",
    "addConfig": "افزودن پیکربندی",
    "stockSymbol": "نماد",
    "price": "قیمت",
    "startDate": "تاریخ شروع",
    "endDate": "تاریخ پایان",
    "isActive": "فعال است",
    "action": "عملیات",
    "edit": "ویرایش",
    "delete": "حذف",
    "addConfigTitle": "افزودن پیکربندی آنالیز آزمایشگاه",
    "stockSymbolName": "نام نماد",
    "priceLabel": "قیمت",
    "labExpertUser": "کارشناس آزمایشگاه",
    "approvedStockSymbol": "نماد تایید شده",
    "stockSymbolOwnerSelfDeclaration": "نماد اظهارشده توسط مالک",
    "approved_true": "تایید شده",
    "approved_false": "تایید نشده",
    "isConfigActive": "فعال بودن پیکربندی",
    "cancel": "انصراف",
    "save": "ذخیره",
    "editTitle": "ویرایش آنالیز آزمایشگاه",
    "addTitle": "ثبت آنالیز آزمایشگاه",
    "analysisDate": "تاریخ آنالیز",
    "analysisReport": "گزارش آنالیز",
    "approved": "تایید شده",
    "approvedQuantity": "تعداد تایید شده",
    "selectStockSymbol": "انتخاب نماد",
    "uploadReportFile": "بارگذاری فایل گزارش",
    "setUnit": "تخصیص یونیت",
    "result": {
      "title": "نتیجه آنالیز آزمایشگاه",
      "analysisDate": "تاریخ آنالیز",
      "result": "نتیجه",
      "expertName": "نام کارشناس",
      "comments": "توضیحات",
      "confirm": "تایید و تبدیل به توکن",
      "cancel": "انصراف"
    },
    "error": "خطایی رخ داده است",
    "validation": {
      "quantityRequired": "مقدار الزامی است",
      "quantityMin": "حداقل مقدار باید بیشتر از صفر باشد",
      "analysisDateRequired": "تاریخ آنالیز الزامی است",
      "stockSymbolRequired": "انتخاب نماد الزامی است",
      "analysisReportRequired": "گزارش آنالیز الزامی است"
    },
    "status": {
      "PENDING": "درحال تعیین و تکلیف",
      "CONVERTED": "توکنایز شده",
      "CANCELED": "کنسل شده"
    }
  },
  "releaseGoods": {
    "title": "پیکربندی قیمت ترخیص کالا از انبار",
    "addConfig": "افزودن پیکربندی جدید",
    "stockSymbol": "نماد کالا",
    "price": "قیمت",
    "setDeliverTime": "تعیین زمان  تحویل کالا ",
    "startDelivering": "  شروع بارگیری ",
    "assignBundleNumber": " وارد کردن باندل های تخصیص داده شده  ",
    "delivered": " تحویل شده ",
    "setDeliver": "وضعیت کالا به تحویل شده تبدیل شود",
    "startDate": "تاریخ شروع",
    "endDate": "تاریخ پایان",
    "isActive": "فعال است",
    "action": "عملیات",
    "edit": "ویرایش",
    "delete": "حذف",
    "addConfigTitle": "افزودن پیکربندی قیمت ترخیص کالا از انبار",
    "stockSymbolName": "نام نماد کالا (نوع کالا)",
    "priceLabel": "قیمت",
    "isConfigActive": "آیا پیکربندی فعال است؟",
    "cancel": "انصراف",
    "save": "ذخیره",
    "warehousemanFullName": "انبار دار",
    "bundlePlacement": "محل قرارگیری باندل",
    "warehouseName": "انبار",
    "validation": {
      "quantityRequired": "مقدار الزامی است",
      "quantityMin": "حداقل باید ۱ باشد"
    },
    "status": {
      "REQ_RELEASE": "درخواست خروج",
      "ASSIGNED_DELIVER_TIME": "زمان خروج مشخص شده",
      "LOADING_IN_WAREHOUSE": "درحال بارگیری در انبار",
      "RELEASE_CANCELED": "کنسل شده",
      "DELIVERED": "خارج شد"
    }
  },
  "stockSymbolAdd": {
    "nameLabel": "نام",
    "nameRequired": "نام شرکت الزامی است",
    "commentLabel": "توضیحات",
    "faUnitLabel": "واحد اندازه‌گیری (فارسی)",
    "enUnitLabel": "واحد اندازه‌گیری (انگلیسی)",
    "minimumWeight": "حداقل وزن مجاز",
    "updateButton": "به‌روزرسانی",
    "saveButton": "ذخیره"
  },
  "stockSymbol": {
    "list": {
      "title": "نمادهای سهام",
      "add": "افزودن نماد سهام",
      "loading": "در حال بارگذاری...",
      "error": "خطا در بارگذاری داده‌ها.",
      "header": {
        "index": "ردیف",
        "title": "نام",
        "name": "نماد",
        "comment": "توضیحات",
        "faUnit": "واحد فارسی",
        "enUnit": "واحد انگلیسی",
        "status": "وضعیت"
      },
      "status": {
        "ACTIVE": "فعال(قابل‌ترید)",
        "TRADE_STOP": "متوقف",
        "TRADE_STOP_HIDE": "متوقف(مخفی شده)"
      }
    }
  },
  "wallet": {
    "charge": "واریز وجه",
    "moneyRequest": "برداشت وجه",
    "moneyWalletPayById": "واریز با شناسه",
    "myBalance": "موجودی من",
    "yourBalance": "موجودی شما",
    "yourStockBalance": "موجودی دارایی شما",
    "insufficientFunds": "موجودی شما کافی نیست.",
    "insufficientStock": "دارایی شما کافی نیست.",
    "loadStockBalanceFailed": "خطا در دریافت موجودی",
    "loadingData": "در حال دریافت اطلاعات مارکت",
    "loadingStockBalance": "در حال دریافت اطلاعات دارایی شما",
    "loadDataFailed": "خطا در دریافت موجودی",
    "paginatorReport": "نمایش {first} تا {last} از {totalRecords} مورد",
    "LaboratoryFee": "هزینه آزمایشگاه",
    "StorageCost": "هزینه انبارداری",
    "TotalCost": "هزینه کل",
    "addCard": "افزودن کارت",
    "description": "توضیحات",
    "statusSelect": "وضعیت انتخابی",
    "yourCards": "کارت‌های شما",
    "selectCardPLZ": "لطفا کارت خود را انتخاب کنید",
    "status": {
      "transaction": {
        "CREDIT": "افزایش اعتبار",
        "CHARGE_ONLINE": "شارژ آنلاین",
        "SHAPARAK_FEE": "کارمزد درگاه بانک",
        "CHARGE_BANK_RECEIPT": "افزایش اعتبار با فیش بانکی",
        "REVERSE_BY_ADMIN": "عودت وجه",
        "MONEY_REQUEST": "درخواست وجه",
        "MONEY_REQUEST_FEE": "کار مزد درخواست وجه",
        "BUY_STOCK": "خرید سهم",
        "SELL_STOCK": "فروش سهم",
        "BUY_STOCK_FEE": "کارمزد خرید",
        "SELL_STOCK_FEE": "کارمزد فروش",
        "GOODS_TO_WAREHOUSE_FEE": "کارمزد انبارداری",
        "GOODS_ANALYSIS_FEE": "کارمزد آزمایشگاه",
        "RELEASE_FROM_WAREHOUSE": "کارمزد خروج از انبار",
        "RELEASE_FROM_WAREHOUSE_FEE": "کارمزد سیستم خروج از انبار",
        "SELL_STOCK_VAT": "ارزش افزوده",
        "BUY_STOCK_VAT": "ارزش افزوده",
        "REFERRAL": "هدیه کد دعوت"
      },
      "payment": {
        "ACCEPTED": "تایید شده",
        "BLOCKED": "بلوکه شده",
        "REJECTED": "رد شده",
        "WAITING": "در انتظار",
        "WAITING_BANK": "در انتظار تایید بانک",
        "WAITING_FOR_ADMIN": "در انتظار تایید مدیر"
      }
    },
    "header": {
      "index": "ردیف",
      "amount": "مبلغ‌کل(﷼)",
      "date": "تاریخ",
      "transactionType": "نوع تراکنش",
      "status": "وضعیت",
      "user": "شخص",
      "resNum": "شناسه واریز"
    },
    "chargeModal": {
      "title": "شارژ کیف پول",
      "amountLabel": "مبلغ :",
      "cancel": "انصراف",
      "save": "ذخیره"
    },
    "callback": {
      "verifying": "در حال تایید تراکنش، لطفاً شکیبا باشید...",
      "successTitle": "پرداخت موفق",
      "successMessage": "کیف پول شما با موفقیت شارژ شد.",
      "backToWallet": "بازگشت به کیف پول",
      "failedTitle": "پرداخت ناموفق",
      "userCancelled": "تراکنش توسط شما لغو شده و یا با خطا مواجه گردیده است. در صورت کسر موجودی از حساب شما نهایتا طی ۳۰ دقیقه الی ۷۲ ساعت به حساب شما برگشت داده میشود.",
      "serverError": "خطای سرور هنگام تایید تراکنش.",
      "retry": "تلاش مجدد"
    }
  },
  "inboundGoodsRequest": {
    "title": "درخواست ورود کالا به انبار",
    "quantityInfo": "اطلاعات مقداری",
    "stockSymbolName": "نماد کالا",
    "initialQuantity": "مقدار اولیه",
    "bundleCount": "تعداد بسته",
    "bundleWeight": "وزن بسته (کیلوگرم)",
    "driverInfo": "اطلاعات راننده",
    "driverName": "نام راننده",
    "driverMobile": "موبایل راننده",
    "driverCar": "خودرو راننده",
    "licensePlate": "پلاک خودرو",
    "deliveryComments": "توضیحات تحویل",
    "submit": "ثبت درخواست",
    "reset": "بازنشانی",
    "validation": {
      "quantityRequired": "مقدار الزامی است",
      "quantityMin": "حداقل باید ۱ باشد",
      "bundleCountRequired": "تعداد بسته الزامی است",
      "bundleWeightRequired": "وزن بسته الزامی است",
      "bundleWeightMin": "باید بیشتر از ۰ باشد",
      "driverNameRequired": "نام راننده الزامی است",
      "mobileRequired": "شماره موبایل الزامی است",
      "mobilePattern": "لطفا یک شماره موبایل معتبر وارد کنید",
      "carInfoRequired": "اطلاعات خودرو الزامی است",
      "licensePlateRequired": "پلاک خودرو الزامی است"
    }
  },
  "orderForm": {
    "stockSymbol": "نماد",
    "selectStockPrompt": "نماد را انتخاب کنید.",
    "orderType": "نوع سفارش",
    "transactionType": "نوع تراکنش",
    "trade_list": "لیست معاملات",
    "noTradesFound": "معاملات یافت نشد",
    "buy": "خرید",
    "sell": "فروش",
    "quantity": "تعداد",
    "price": "قیمت",
    "submit": "ثبت",
    "paste": "جاگذاری",
    "sending": "در حال ارسال...",
    "LIMIT": "با تعیین قیمت",
    "limit_info": "سفارش در قیمتی که تعیین می‌کنید یا قیمتی بهتر از آن انجام می‌شود. انجام شدن و سرعت انجام سفارش، به قیمت تعیین شده بستگی دارد.",
    "MARKET": "سریع",
    "market_info": "سفارش به صورت آنی، با بهترین قیمت در بازار انجام می‌شود. به دلیل نوسانات قیمت، ممکن است معامله نهایی با کمی تفاوت نسبت به مقادیری که نمایش داده می‌شود، انجام شود.",
    "marketOrderPriceNotice": "بهترین قیمت به صورت خودکار",
    "validation": {
      "quantityRequired": "تعداد الزامی است",
      "quantityMin": "تعداد باید حداقل ۱ باشد",
      "priceRequired": "قیمت الزامی است",
      "priceMin": "قیمت باید مثبت باشد"
    },
    "orderPlacedSuccessfully": "سفارش با موفقیت ثبت شد!",
    "orderFailed": "ثبت سفارش ناموفق بود. لطفاً دوباره تلاش کنید.",
    "readyToExecute": "آماده اجرا",
    "notReadyToExecute": "در انتظار شرایط اجرا",
    "insufficientFunds": "موجودی کافی نیست",
    "insufficientStock": "موجودی سهام کافی نیست",
    "quickActions": "اقدامات سریع",
    "quickPresets": "پیش‌تنظیمات سریع",
    "priceShortcuts": "میانبرهای قیمت",
    "bestBid": "بهترین پیشنهاد خرید",
    "bestAsk": "بهترین پیشنهاد فروش",
    "lastPrice": "آخرین قیمت",
    "marketPrice": "قیمت بازار",
    "orderPreview": "پیش‌نمایش سفارش",
    "previewOrder": "پیش‌نمایش سفارش",
    "orderSummary": "خلاصه سفارش",
    "stock": "سهام",
    "orderTypePreview": "نوع سفارش",
    "quantityPreview": "تعداد",
    "pricePreview": "قیمت",
    "grossAmount": "مبلغ کل",
    "feeAmount": "کارمزد",
    "netAmount": "مبلغ خالص",
    "currentMarketPrice": "قیمت فعلی بازار",
    "priceImpact": "تأثیر قیمت",
    "executionProbability": "احتمال اجرا",
    "estimatedExecutionTime": "زمان تخمینی اجرا",
    "high": "بالا",
    "medium": "متوسط",
    "low": "پایین",
    "immediate": "فوری",
    "confirmAndExecute": "تأیید و اجرا",
    "editOrder": "ویرایش سفارش",
    "invalidOrder": "سفارش نامعتبر",
    "pleaseFillRequiredFields": "لطفاً تمام فیلدهای الزامی را پر کنید",
    "simulationNote": "این یک شبیه‌سازی بر اساس شرایط فعلی بازار است. اجرای واقعی ممکن است متفاوت باشد.",
    "priceImpactNote": "تأثیر قیمت نشان می‌دهد که سفارش شما چگونه ممکن است بر قیمت بازار تأثیر بگذارد.",
    "executionProbabilityNote": "بر اساس عمق فعلی بازار و پارامترهای سفارش شما.",
    "quickPresetApplied": "پیش‌تنظیم سریع اعمال شد",
    "quickPresetAppliedDetail": "پیش‌تنظیم {{preset}} اعمال شد",
    "switchedToBuy": "تغییر به حالت خرید",
    "switchedToSell": "تغییر به حالت فروش",
    "marketOrderSelected": "سفارش سریع انتخاب شد",
    "limitOrderSelected": "سفارش با تعیین قیمت انتخاب شد",
    "marketAnalysis": "تحلیل بازار",
    "seconds": "ثانیه‌ها",
    "minutes": "دقیقه‌ها",
    "hoursUncertain": "ساعت‌ها/ نامشخص",
    "market": "بازار",
    "bid": "پیشنهاد خرید",
    "ask": "پیشنهاد فروش",
    "last": "آخرین",
    "useMarketPrice": "استفاده از قیمت بازار",
    "current": "فعلی"
  },
  "login": {
    "title": "ورود به حساب کاربری",
    "username": "نام کاربری",
    "password": "رمز عبور",
    "submit": "ورود"
  },
  "landing": {
    "title": "به سامانه معاملات سهام خوش آمدید",
    "subtitle": "لطفاً برای دسترسی به داشبورد خود وارد شوید",
    "login": "ورود",
    "panel": "پنل کاربری",
    "logout": "خروج",
    "aboutTitle": "درباره سامانه",
    "aboutText": "این سامانه به شرکت‌ها و افراد کمک می‌کند تا معاملات، موجودی و انطباق را به صورت لحظه‌ای مدیریت کنند.",
    "contactTitle": "تماس با ما",
    "contactEmail": "ایمیل پشتیبانی"
  },
  "roles": {
    "LEGAL": " حقوقی",
    "REAL": " حقیقی",
    "SUPER_ADMIN": "ادمین",
    "CLINIC_ADMIN": " مدیر کلینیک",
    "SALON_ADMIN": " مدیر سالن",
    "SELLER_USERS": " فروشنده",
    "SELLER_USER": " فروشنده",
    "TRAINEE_USER": " هنرجو/بیوتی‌آرتیست",
    "TRAINER_USER": "مدرس",
    "USER": "کاربر عادی",
    "traderDesc": "معاملات، سبد سهام و سفارش‌های خود را به‌صورت زنده دنبال کنید.",
    "warehouseDesc": "در سامانه تاداپلاس، انباردار نقش کلیدی در زنجیره معاملات ایفا می‌کند و مسئولیت تحویل، نگهداری و مدیریت موجودی فلزات، به‌ویژه فلز روی، را بر عهده دارد. پس از انجام معامله میان خریدار و فروشنده، انباردار موظف است فلز  را طبق مشخصات ثبت‌شده دریافت کرده، آن را به‌صورت استاندارد نگهداری نموده و در زمان مقرر به خریدار تحویل دهد. این فرآیند با هدف تضمین سلامت، اصالت و امنیت کالای مبادله‌شده طراحی شده و در چارچوبی شفاف و قابل‌پیگیری از طریق سامانه تاداپلاس اجرا می‌شود.",
    "labDesc": "در سامانه تاداپلاس، آزمایشگاه نقش مهمی در تضمین کیفیت و اصالت فلزات معامله‌شده ایفا می‌کند. پس از ورود کالا به انبار، نمونه‌برداری توسط کارشناسان مجرب آزمایشگاه انجام می‌شود و با استفاده از تجهیزات دقیق، مشخصات فنی و ترکیب شیمیایی فلز مورد بررسی قرار می‌گیرد. این فرآیند نه‌تنها صحت ادعای فروشنده را تأیید می‌کند، بلکه اطمینان خاطر خریداران را از بابت کیفیت و استاندارد بودن کالا فراهم می‌سازد. ",
    "bannerDesc": "سامانه تاداپلاس، بستری نوین برای تسهیل و شفاف‌سازی معاملات فلزات در بازار داخلی است که فعالیت خود را با تمرکز بر فلز روی آغاز کرده است. این سامانه با بهره‌گیری از فناوری‌های روز، امکان ثبت سفارش، تطبیق عرضه و تقاضا، و مدیریت فرآیندهای مرتبط با خرید و فروش فلزات را به صورت آنلاین فراهم می‌سازد. تاداپلاس با هدف ایجاد بازاری شفاف، رقابتی و کارآمد، بستری مطمئن برای فعالان حوزه فلزات فراهم کرده و در آینده نزدیک قصد دارد دامنه فعالیت خود را به سایر فلزات گسترش دهد.",
    "adminDesc": "مدیریت کاربران، تنظیمات و کنترل کامل سامانه.",
    "LABORATORY": "آزمایشگاه",
    "more": "بیشتر"
  },
  "signup": {
    "title": "ایجاد حساب کاربری",
    "name": "نام کامل",
    "email": "ایمیل",
    "password": "رمز عبور",
    "submit": "ثبت‌نام",
    "createAccountLink": "حساب کاربری ندارید؟ ثبت‌نام کنید",
    "errors": {
      "nameRequired": "وارد کردن نام الزامی است",
      "emailInvalid": "ایمیل نامعتبر است",
      "passwordShort": "رمز عبور باید حداقل ۶ کاراکتر باشد"
    }
  },
  "adminDashboard": {
    "tradingVolume": "حجم معاملات",
    "totalTraders": "تعداد معامله‌گران",
    "warehouseStock": "موجودی انبار",
    "labPending": "آزمایش‌های در انتظار",
    "item": "کالا",
    "quantity": "تعداد"
  },
  "footer": {
    "rights": "کلیه حقوق محفوظ است.",
    "backToTop": "بازگشت به بالا",
    "accessibility": "دسترسی ها",
    "contact us": "ارتباط با ما",
    "customer service": "خدمات مشتریان"
  },
  "app": {
    "title": "BEAUTYBOSS",
    "description": "اولین دستیار هوش مصنوعی صنعت زیبایی"
  },
  "aboutUs": {
    "title": "درباره ما",
    "description": "ما یک پلتفرم پیشرو در معاملات سهام هستیم که تحلیل‌های بلادرنگ و تجربه‌ای امن برای معامله‌گران، مدیران و کاربران فراهم می‌کنیم."
  },
  "contactUs": {
    "title": "تماس با ما",
    "name": "نام",
    "email": "ایمیل",
    "message": "پیام",
    "send": "ارسال پیام",
    "phoneNumber": "شماره تلفن"
  },
  "laboratory": {
    "management": "مدیریت آزمایشگاه",
    "title": "نام آزمایشگاه",
    "item": "کالا",
    "quantity": "تعداد",
    "evaluation": "ارزیابی",
    "symbol": "نماد",
    "evaluate": "ارزیابی",
    "formTitle": "فرم آزمایشگاه",
    "code": "کد آزمایشگاه",
    "assignLabExpert": "تخصیص کارشناس آزمایشگاه",
    "active": "فعال",
    "inactive": "غیرفعال",
    "selectIsActive": "انتخاب وضعیت فعال بودن",
    "stockSymbols": "نمادهای سهام",
    "selectStockSymbols": "انتخاب نمادهای سهام",
    "expanded": {
      "labExperts": "کارشناسان {{lab}} : ",
      "emptyMessage": "کارشناسی برای {{lab}} یافت نشد"
    }
  },
  "warehouse": {
    "management": "مدیریت انبار",
    "detailsOfGoodsRelease": "جزئیات حواله خروج از انبار",
    "shed": {
      "title": "سوله",
      "addTitle": "افزودن سوله",
      "editTitle": "ویرایش سوله",
      "code": "کد"
    },
    "addShed": " ساخت سوله ",
    "deleteShed": " حذف سوله ",
    "editShed": " ویرایش سوله ",
    "corridor": {
      "title": " راهرو ",
      "addTitle": "ساخت راهرو",
      "editTitle": "ویرایش راهرو",
      "code": "کد"
    },
    "addCorridor": "ساخت راهرو ",
    "label": " برچسب ",
    "unitContent": " باندل های موجود در یونیت   ",
    "emptyUnitContent": "  هیچ کالایی در یونیت وجود ندارد   ",
    "selectedWeight": "   وزن برداشت شده ",
    "unit": {
      "title": "یونیت",
      "code": "کد",
      "storageCapacity": "ظرفیت",
      "currentOccupancy": "ظرفیت استفاده شده",
      "totalArea": "کل فضا",
      "usableArea": "فضای قابل استفاده",
      "addTitle": "ساخت یونیت",
      "editTitle": "ویرایش یونیت",
      "move": "جا به جایی یونیت"
    },
    "title": "نام انبار",
    "code": "کد انبار",
    "item": "کالا",
    "volume": "حجم",
    "owner": "مالک",
    "manage": "مدیریت",
    "warehouseStatus": "وضعیت انبار",
    "address": {
      "legend": "آدرس انبار",
      "street": "خیابان",
      "city": "شهر",
      "state": "استان",
      "postalCode": "کد پستی",
      "postalCodeWrong": "کد پستی اشتباه است.",
      "country": "کشور",
      "detail": "جزئیات آدرس",
      "googleUrl": "لینک گوگل‌مپ",
      "googleUrlTitle": "برای مشاهده روی نقشه گوگل اینجا کلیک کنید"
    },
    "totalArea": "مساحت کل",
    "usableArea": "مساحت قابل استفاده",
    "status": "وضعیت",
    "assignLabExpert": "تخصیص متخصص آزمایشگاه",
    "establishedDate": "تاریخ تأسیس",
    "lastInventoryDate": "تاریخ آخرین موجودی",
    "storageCapacity": "ظرفیت ذخیره‌سازی",
    "currentOccupancy": "اشغال فعلی",
    "goodsCategoryList": "دسته‌های کالا",
    "goodsSubCategoryList": "زیرمجموعه‌های کالا",
    "selectGoodsCategories": "انتخاب دسته‌های کالا",
    "selectGoodsSubCategories": "انتخاب زیرمجموعه‌های کالا",
    "selectWarehouseman": "انتخاب مسئول انبار",
    "validators": {
      "usableBiggerThanTotal": "مساحت کل باید بزرگتر یا برابر مساحت قابل استفاده باشد."
    },
    "expanded": {
      "warehouseman": "انبارداران  {{warehouse}}: ",
      "emptyMessage": "انبارداری برای {{warehouse}} یافت نشد"
    },
    "statusList": {
      "ACTIVE": "فعال",
      "INACTIVE": "غیرفعال",
      "UNDER_MAINTENANCE": "در حال تعمیر و نگهداری"
    },
    "outbound": {
      "selectedItemName": "نام کالای انتخاب شده برای خروج از انبار :",
      "maxExitVolume": "حداکثر حجم قابل خروج :",
      "ninetyFivePercentTooltip": "به دلیل ضریب خطای شمش های موجود، حداکثر حجم قابل خروج از انبار ۹۵٪ دارایی شما می‌باشد.",
      "warehouseInventory": "موجودی انبار :",
      "selectWarehouse": "انتخاب انبار",
      "noWarehouseFound": "انباری کالای موردنظر را ندارد.",
      "dialogTitle": "فرم خروج کالا از انبار",
      "exitVolumeLabel": "حجم خروج",
      "maxCapacityError": "شما قادر به برداشت حداکثر ۹۵٪ موجودی خود می‌باشید.",
      "requiredCost": "هزینه مورد نیاز",
      "insufficientBalance": "کمبود موجودی",
      "quantityExceedsWarehouse": "حجم درخواستی از حجم موجود در انبار بیشتر است.",
      "continue": "ادامه"
    }
  },
  "user": {
    "title": "مدیریت کاربران",
    "userType": "حقیقی/حقوقی ",
    "identity": "کد ملی",
    "createdDate": "تاریخ ثبت نام",
    "firstName": "نام",
    "lastName": "نام خانوادگی",
    "username": "نام کاربری",
    "mobileNumber": "شماره موبایل",
    "shahkar": "احراز شاهکار",
    "address": "آدرس",
    "gender": "جنسیت",
    "role": "نقش",
    "filterRole": "فیلتر بر اساس نقش",
    "email": "ایمیل",
    "all": "همه",
    "selectRoles": "انتخاب نقش‌ها",
    "selectUserType": "انتخاب نوع کاربر",
    "paginatorReport": "نمایش {first} تا {last} از {totalRecords} مورد",
    "addUser": "افزودن کاربر جدید",
    "editUser": "ویرایش کاربر",
    "changeStatus": "تغییر وضعیت",
    "blockConfirmTitle": "مسدود کردن کاربر",
    "blockConfirmText": "آیا از مسدود کردن این کاربر مطمئن هستید؟",
    "unblockConfirmTitle": "رفع مسدودیت کاربر",
    "unblockConfirmText": "آیا از رفع مسدودیت این کاربر مطمئن هستید؟",
    "blockSuccess": "کاربر با موفقیت مسدود شد",
    "unblockSuccess": "مسدودیت کاربر با موفقیت رفع شد",
    "header": {
      "index": "ردیف",
      "identity": "کد ملی",
      "firstName": "نام",
      "lastName": "نام خانوادگی",
      "mobileNumber": "شماره موبایل",
      "role": "نقش",
      "actions": "عملیات"
    }
  },
  "genders": {
    "MALE": "مرد",
    "FEMALE": "زن",
    "OTHER": "سایر"
  },
  "validation": {
    "nationalCode": "کد ملی باید ۱۰ رقمی باشد",
    "mobile": "شماره موبایل باید با 09 شروع و 11 رقمی باشد",
    "identity": "لطفا کد ملی معتبر وارد کنید.",
    "mobileNumber": "لطفا شماره موبایل معتبر وارد کنید.",
    "email": "لطفا یک آدرس ایمیل معتبر وارد کنید."
  },
  "add": "افزودن",
  "back": "بازگشت",
  "update": "به‌روزرسانی",
  "reset": "پاک‌کردن",
  "edit": "ویرایش",
  "delete": "حذف",
  "select": "انتخاب",
  "action": "عملیات",
  "save": "ذخیره",
  "excel": "اکسل",
  "block": "مسدود کردن",
  "unblock": "رفع مسدودیت",
  "cancel": "انصراف",
  "filters": {
    "username": "لطفا نام کاربری مورد نظر را وارد کنید",
    "searchTerm": "نام کاربری را وارد کنید",
    "startDate": "تاریخ شروع",
    "endDate": "تاریخ پایان",
    "fromAmount": "از مبلغ",
    "toAmount": "تا مبلغ",
    "fromQuantity": "تعداد از",
    "toQuantity": "تعداد تا",
    "birthDate": "تاریخ تولد",
    "status": "وضعیت"
  },
  "activeDevices": {
    "expandAll": "نمایش همه",
    "collapseAll": "بستن همه",
    "kick": "بیرون انداختن",
    "header": {
      "index": "ردیف",
      "device": "دستگاه",
      "os": "سیستم عامل",
      "osVersion": "نسخه سیستم عامل",
      "current": "فعلی",
      "mobile": "موبایل",
      "lastAccess": "آخرین دسترسی"
    },
    "boolean": {
      "yes": "بله",
      "no": "خیر"
    },
    "expanded": {
      "sessionsFor": "جلسات برای {{device}}",
      "header": {
        "index": "ردیف",
        "ip": "آی‌پی",
        "browser": "مرورگر",
        "started": "شروع شده",
        "lastAccess": "آخرین دسترسی",
        "expires": "منقضی می‌شود"
      },
      "emptyMessage": "هیچ جلسه‌ای برای این دستگاه وجود ندارد."
    }
  },
  "topbar": {
    "calendar": "تقویم",
    "messages": "پیام‌ها",
    "profile": "پروفایل",
    "swichLang": "تغییر زبان"
  },
  "messageService": {
    "add": {
      "success": "با موفقیت ایجاد شد",
      "error": "ایجاد با خطا مواجه شد"
    },
    "update": {
      "success": "با موفقیت ویرایش شد",
      "error": "ویرایش با خطا مواجه شد"
    },
    "delete": {
      "success": "با موفقیت حذف شد",
      "error": "حذف با خطا مواجه شد"
    }
  },
  "agreementTemplates": {
    "title": "قالب‌های قرارداد",
    "addNew": "افزودن قالب جدید",
    "edit": "ویرایش قالب",
    "delete": "حذف قالب",
    "loading": "در حال بارگذاری...",
    "empty": "هیچ قالب قراردادی یافت نشد",
    "form": {
      "title": "عنوان",
      "sectionKey": "کلید بخش",
      "agreementType": "نوع قرارداد",
      "content": "محتوا",
      "active": "فعال",
      "newTemplate": "قالب قرارداد جدید",
      "editTemplate": "ویرایش قالب"
    },
    "agreementTypes": {
      "SIMPLE_ACCEPTANCE": "پذیرش ساده",
      "SIGNATURE_REQUIRED": "نیاز به امضا"
    },
    "validation": {
      "titleRequired": "عنوان الزامی است",
      "sectionKeyRequired": "کلید بخش الزامی است",
      "contentRequired": "محتوا الزامی است"
    },
    "messages": {
      "createSuccess": "قالب قرارداد با موفقیت ایجاد شد",
      "createError": "ایجاد قالب قرارداد ناموفق بود",
      "updateSuccess": "قالب قرارداد با موفقیت بروزرسانی شد",
      "updateError": "بروزرسانی قالب قرارداد ناموفق بود",
      "deleteSuccess": "قالب قرارداد با موفقیت حذف شد",
      "deleteError": "حذف قالب قرارداد ناموفق بود",
      "deleteConfirm": "آیا از حذف اطمینان دارید؟",
      "validationError": "لطفاً تمام فیلدهای الزامی را پر کنید",
      "loadError": "بارگذاری قالب‌های قرارداد ناموفق بود"
    }
  },
  "goodsToWarehouse": {
    "trackingNumber": "کد پیگیری",
    "owner": "مالک",
    "goodsSubCategory": "زیرمجموعه کالا",
    "warehouse": "انبار",
    "warehouseman": "مسئول انبار",
    "initialQuantity": "وزن کلی اعلام شده",
    "initSymbol": "نماد اعلام شده",
    "remainedQuantity": "وزن موجود",
    "bundleCount": "تعداد بسته",
    "bundleWeight": "وزن بسته",
    "status": "وضعیت",
    "requestDate": "تاریخ درخواست",
    "receivedDate": "تاریخ تحویل",
    "receivedBundleCount": "تعداد بسته تحویل شده",
    "scheduledDateToDeliverInWarehouse": "تاریخ جهت تحویل",
    "goodsToWarehousingPrice": "هزینه انبارداری",
    "labAnalysisPrice": "هزینه تحلیل آزمایشگاهی",
    "driverName": "نام راننده",
    "driverMobile": "موبایل راننده",
    "driverCar": "خودرو راننده",
    "licensePlate": "پلاک خودرو",
    "deliveringCommentsFromRequester": "توضیحات درخواست‌کننده",
    "deliveringCommentsFromWarehouseman": "توضیحات مسئول انبار",
    "assignedLaboratory": "آزمایشگاه اختصاص داده‌شده",
    "approvedQuantity": "مقدار تایید شده",
    "approveWeight": "تایید وزن کشی",
    "approveWeightConfirmation": "آیا از تایید وزن کشی اطمینان دارید؟",
    "updateWeightSuccessMessage": "وزن کشی با موفقیت تایید شد",
    "setWarehouse": "تخصیص انبار",
    "assignLaboratory": "تعیین آزمایشگاه",
    "assignDeliveryTime": "تعیین زمان تحویل",
    "assignLabAnalysis": "ثبت نتیجه آزمایشات",
    "receivedInWarehouse": "زمان تحویل در انبار",
    "setWarehouseDialogHeader": "تخصیص انبار",
    "assignDeliverTimeDialogHeader": "تعیین زمان تحویل",
    "receivedInWarehouseDialogHeader": "زمان تحویل در انبار",
    "labAnalysisResult": "مشاهده نتیجه آزمایشات",
    "goodsBundleLabAnalysis": "ثبت نتیجه آزمایشات",
    "goodsBundleLabAnalysisResult": "نتیجه آزمایشات",
    "seeGoodsBundleLabAnalysisResult": "مشاهده نتیجه آزمایشات",
    "updateDriverInformation": "ویرایش اطلاعات راننده ",
    "delete": "حذف ",
    "labAnalysisMismatch": "تعیین و تکلیف مغایرت",
    "assignUnitToBundle": "توزین باندل ها",
    "statusList": {
      "NEW": "درخواست جدید",
      "REQ_WAREHOUSED": "تعیین زمان/مکان تحویل کالا",
      "ASSIGNED_DELIVER_TIME": "زمان/مکان تحویل اعلام شده",
      "DELIVERED_IN_WAREHOUSE": "تحویل در انبار و شروع وزن‌کشی",
      "APPROVED_WEIGHT": "وزن کشی تایید شده",
      "PENDING_ANALYSIS": "در انتظار آنالیز",
      "LAB_ANALYSIS_RESULT_IS_READY": "نتیجه آنالیز آماده است",
      "CANCELED_WAREHOUSING": "لغو انبارداری",
      "PARTIALLY_CANCELED": "بخشی لغو شده ",
      "CONVERTED_TO_STOCKS": "تبدیل شده به سهام",
      "RESULT_MISMATCH": "تناقض بین نتایج آزمایشگاه و نماد اظهار شده"
    },
    "releaseFromShed": {
      "reqQuantity": "مقدار درخواست داده شده",
      "deliveredQuantity": "مقدار تحویل داده شده"
    },
    "validation": {
      "maxBundleCount": "تعداد بسته ها صحیح نمی‌باشد"
    }
  },
  "cancelGoodsToWarehouse": {
    "releasedDate": "زمان خروج از انبار",
    "statusList": {
      "PENDING": "ثبت اولیه",
      "REQ_RELEASE": "درخواست انبارداری",
      "ASSIGNED_DELIVER_TIME": "زمان تحویل اختصاص داده شده",
      "LOADING_IN_WAREHOUSE": "در حال بارگیری",
      "DELIVERED": "تحویل در انبار"
    }
  },
  "canceledGoodsList": {
    "updateDriverInfo": "به‌روزرسانی اطلاعات راننده"
  },
  "updateDriverInfo": {
    "submit": "به‌روزرسانی اطلاعات راننده",
    "error": "خطا",
    "errorMessage": "خطا در به‌روزرسانی اطلاعات راننده",
    "validationError": "خطای اعتبارسنجی",
    "validationErrorMessage": "لطفاً تمام فیلدهای لازم را به درستی پر کنید"
  },
  "stockDetails": {
    "loading": "در حال بارگذاری اطلاعات...",
    "error": "خطایی در دریافت اطلاعات رخ داد.",
    "empty": "اطلاعاتی برای نمایش وجود ندارد.",
    "currentPrice": "قیمت فعلی",
    "dailyVolume": "حجم روزانه",
    "dayHigh": "بیشترین قیمت روزانه",
    "dayLow": "کمترین قیمت روزانه",
    "yearHigh": "بیشترین سالانه",
    "yearLow": "کمترین قیمت سالانه"
  },
  "stockWalletDetails": {
    "title": "تاریخچه نماد",
    "loading": "در حال بارگذاری تراکنش‌ها...",
    "error": "خطا در بارگذاری تراکنش‌ها",
    "empty": "هیچ تراکنشی یافت نشد",
    "transactionType": "نوع تراکنش",
    "paymentStatus": "وضعیت پرداخت",
    "amount": "تعداد",
    "coefficient": "ضریب",
    "dateOfTransaction": "تاریخ تراکنش",
    "description": "توضیحات",
    "traceCode": "کد پیگیری",
    "summary": {
      "totalBuy": "مجموع خرید",
      "totalSell": "مجموع فروش",
      "totalFees": "مجموع کارمزد‌ها",
      "pendingTransactions": "تراکنش‌های در انتظار",
      "netBalance": "خالص موجودی"
    },
    "transactionTypes": {
      "BUY": "خرید",
      "SELL": "فروش",
      "FEE": "کارمزد",
      "GOODS_TO_WAREHOUSE": "ورود به انبار",
      "RELEASE_FROM_WAREHOUSE": "خروج از انبار"
    },
    "paymentStatuses": {
      "ACCEPTED": "تایید شده",
      "BLOCKED": "مسدود شده"
    },
    "filters": {
      "symbol": "نماد",
      "transactionType": "نوع تراکنش",
      "paymentStatus": "وضعیت پرداخت",
      "amountRange": "محدوده مبلغ",
      "search": "جستجو",
      "fromAmount": "از مبلغ",
      "toAmount": "تا مبلغ",
      "allTypes": "همه انواع",
      "allStatuses": "همه وضعیت‌ها",
      "clearFilters": "پاک کردن فیلترها",
      "applyFilters": "اعمال فیلترها"
    },
    "timeline": {
      "today": "امروز",
      "yesterday": "دیروز",
      "daysAgo": "{{count}} روز پیش",
      "hoursAgo": "{{count}} ساعت پیش",
      "minutesAgo": "{{count}} دقیقه پیش"
    },
    "loadMore": "نمایش بیشتر",
    "remaining": "مانده"
  },
  "ratioHelp": "این نمودار توزیع حجم در سفارش های خرید و فروش را به درصد نمایش میدهد.",
  "sendPhoto": "ارسال عکس",
  "tour": {
    "help": "راهنما",
    "prevBtnTitle": "قبلی",
    "nextBtnTitle": "بعدی",
    "publishAd": "انتشار آگهی",
    "endBtnTitle": "پایان",
    "welcome_t": "راهنمای استفاده از سامانه",
    "welcome_c": "سلام خیلی خوش آمدید. با من مراحل را طی کنید تا امکانات سامانه را به شما توضیح بدهم.",
    "order0_t": "با تعیین قیمت",
    "order0_c": "سفارش در قیمتی که تعیین می‌کنید یا قیمتی بهتر از آن انجام می‌شود. انجام شدن و سرعت انجام سفارش، به قیمت تعیین شده بستگی دارد.",
    "order1_t": "سریع",
    "order1_c": "سفارش به صورت آنی، با بهترین قیمت در بازار انجام می‌شود. به دلیل نوسانات قیمت، ممکن است معامله نهایی با کمی تفاوت نسبت به مقادیری که نمایش داده می‌شود، انجام شود.",
    "ratioHelp_t": "نمودار توزیع حجم",
    "ratioHelp_c": "این نمودار توزیع حجم در سفارش های خرید و فروش را به درصد نمایش میدهد.",
    "chartHelp_t": "چارت قیمت",
    "chartHelp_c": "با استفاده از این چارت میتوانید قیمت ها و حجم خرید و فروش را در بازه های زمانی مختلف ببینید."
  },
  "referralTimeLine": {
    "step1": "لینک اختصاصی خود را با دوستان به اشتراک بگذارید.",
    "step2": "دوستانتان در تادامارکت ثبت‌نام کنند و معامله انجام دهند.",
    "step3": "پس از انجام اولین معامله،شما و دوستانتان پاداش خود را دریافت خواهید کرد.",
    "submitted": "کد دعوت با موفقیت ثبت شد",
    "not_submitted": "کد دعوت ثبت نشد"
  },
  "CONNECTION": {
    "CONNECTED": "متصل",
    "ATTEMPTING": "در حال اتصال...",
    "DISCONNECTED": "اتصال شما قطع شد",
    "NAME": "وضعیت اتصال"
  },
  "cards": {
    "title": "مدیریت کارت‌ها",
    "card": "کارت",
    "addNew": "افزودن کارت جدید",
    "cardNumber": "شماره کارت",
    "bankName": "نام بانک",
    "status": "وضعیت",
    "default": "پیش‌فرض",
    "secondary": "ثانویه",
    "setDefault": "تنظیم به عنوان پیش‌فرض",
    "delete": "حذف",
    "addCard": "افزودن کارت",
    "noCardsFound": "کارتی یافت نشد",
    "confirmSetDefault": "آیا از تنظیم این کارت به عنوان پیش‌فرض مطمئن هستید؟",
    "addCardDescription": "یک کارت پرداخت جدید به حساب خود اضافه کنید",
    "cardNumberPlaceholder": "شماره کارت ۱۶ رقمی را وارد کنید",
    "cardNumberRequired": "شماره کارت الزامی است و باید ۱۶ رقم باشد",
    "invalidCard": "شماره کارت وارد شده نامعتبر میباشد.",
    "securityNotice": "توجه امنیتی",
    "securityNoticeDescription": "اطلاعات کارت شما به صورت رمزنگاری شده و امن ذخیره می‌شود. ما هرگز شماره کارت کامل شما را ذخیره نمی‌کنیم.",
    "defaultBank": "بانک",
    "actions": "عملیات"
  },
  "adsCompletion": {
    "steps": {
      "basicInfo": "اطلاعات پایه",
      "location": "موقعیت مکانی",
      "PriceAndCooperationModel": "قیمت و مدل همکاری",
      "facility": "امکانات",
      "facilityMediaDesc": "امکانات، تصاویر و توضیحات",
      "photos": "تصاویر",
      "desc": "توضیحات",
      "preview": "پیش نمایش"
    }
  },
  "userProfileCompletion": {
    "title": "تکمیل اطلاعات کاربری",
    "subtitle": "لطفاً اطلاعات خود را تکمیل کنید",
    "steps": {
      "basicInfo": "اطلاعات پایه",
      "userType": "نوع کاربری",
      "bankCardInfo": "اطلاعات کارت بانکی"
    },
    "basicInfoSection": {
      "title": "اطلاعات پایه",
      "description": "در صورت مغایرت اطلاعات از دکمه ویرایش انتهای هر فیلد استفاده کنید.",
      "birthDate": "تاریخ تولد",
      "mobile": "شماره موبایل",
      "nationalId": "کد ملی",
      "continue": "ادامه"
    },
    "addCardSection": {
      "cardAdded": "کارت با موفقیت اضافه شد"
    },
    "userTypeSection": {
      "title": "تغییر به حساب حقوقی",
      "description": "در صورتی که میخواهید به حساب حقوقی تغییر وضعیت دهید، روی دکمه زیر کلیک کنید.",
      "switchToLegal": "درخواست تغییر به حساب حقوقی",
      "requestPending": "درخواست شما برای تغییر به حساب حقوقی ثبت شده است. لطفاً تا زمان تایید توسط مدیر منتظر بمانید. شما تا زمان تایید درخواست قادر به ادامه مراحل نخواهید بود.",
      "requestSuccess": "درخواست شما برای تغییر به حساب حقوقی با موفقیت ارسال شد.",
      "requestError": "در ارسال درخواست شما خطایی رخ داد."
    }
  },
  "dialogs": {
    "legal": {
      "title": "درخواست تغییر به حساب حقوقی",
      "companyName": "نام شرکت",
      "companyNationalId": "شناسه ملی شرکت",
      "companyRegNum": "شماره ثبت شرکت",
      "companyPostalCode": "کد پستی شرکت",
      "companyAddress": "آدرس شرکت",
      "cancel": "انصراف",
      "submit": "ارسال درخواست",
      "sending": "در حال ارسال...",
      "economicCode": "کد اقتصادی"
    },
    "legalUserStatus": {
      "title": "تغییر وضعیت کاربر حقوقی",
      "userLabel": "کاربر",
      "statusLabel": "وضعیت جدید",
      "statusPlaceholder": "انتخاب وضعیت",
      "cancel": "انصراف",
      "update": "به‌روزرسانی وضعیت",
      "updateSuccess": "وضعیت کاربر با موفقیت به‌روزرسانی شد"
    },
    "phone": {
      "title": "تغییر شماره موبایل",
      "newPhoneLabel": "شماره موبایل جدید",
      "placeholder": "09123456789",
      "sendOtp": "ارسال کد تایید",
      "sendingOtp": "در حال ارسال...",
      "otpLabel": "کد تایید را وارد کنید",
      "verifyOtp": "تایید کد",
      "verifyingOtp": "در حال تایید..."
    },
    "identity": {
      "title": "تغییر کد ملی",
      "newIdentityLabel": "کد ملی جدید",
      "placeholder": "1234567890",
      "cancel": "انصراف",
      "update": "به‌روزرسانی",
      "updating": "در حال به‌روزرسانی..."
    },
    "releaseGoodsFromWarehouse": {
      "select": "لطفا ابتدا کالای خود را جهت خروج انتخاب کنید"
    }
  },
  "chat": {
    "title": "پیام‌ها",
    "inbox": "صندوق پیام‌ها",
    "conversation": "گفتگو",
    "send": "ارسال",
    "placeholder": "پیام بنویسید...",
    "back": "بازگشت",
    "viewAd": "مشاهده آگهی",
    "monthlyRent": "اجاره ماهانه",
    "typing": "{{name}} در حال نوشتن…",
    "lastSeen": "آخرین بازدید: {{when}}",
    "sending": "در حال ارسال…",
    "sendFailed": "ارسال ناموفق",
    "retryAll": "{{n}} پیام ارسال نشد — تلاش مجدد؟",
    "retry": "تلاش مجدد",
    "deletedPlaceholder": "این پیام حذف شد",
    "hiddenPlaceholder": "این پیام توسط مدیریت مخفی شد",
    "editedLabel": "ویرایش شد",
    "emptyState": "پیامی وجود ندارد. اولین پیام را ارسال کنید.",
    "chatDisabledByOwner": "گفتگو برای این آگهی توسط آگهی‌دهنده غیرفعال شده است.",
    "userBlockedNotice": "این کاربر را مسدود کرده‌اید. برای ادامه گفتگو ابتدا مسدودیت را رفع کنید.",
    "block": "مسدود کردن",
    "unblock": "رفع مسدودیت",
    "reportConversation": "گزارش تخلف",
    "uploadFailed": "بارگذاری تصویر ناموفق بود",
    "sendBlocked": "ارسال پیام ممکن نشد (احتمالاً مسدود شده‌اید)",
    "blockedToast": "انجام شد",
    "blockedToastDetail": "کاربر مسدود شد",
    "unblockedToastDetail": "مسدودیت رفع شد",
    "reportSubmitted": "ثبت شد",
    "reportSubmittedDetail": "گزارش شما برای بررسی ارسال شد",
    "reportFailed": "ثبت گزارش ناموفق بود",
    "reportReasonLabel": "دلیل گزارش",
    "reportDescriptionLabel": "توضیحات (اختیاری)",
    "reportCancel": "انصراف",
    "reportSubmit": "ثبت گزارش",
    "onlyImage": "فقط تصویر قابل ارسال است",
    "menuCopy": "کپی متن",
    "menuEdit": "ویرایش",
    "menuDelete": "حذف",
    "menuReport": "گزارش این پیام",
    "menuOpenImage": "باز کردن تصویر",
    "confirmDeleteTitle": "حذف پیام",
    "confirmDeleteMsg": "این پیام حذف شود؟",
    "editSave": "ذخیره",
    "editCancel": "انصراف",
    "dateToday": "امروز",
    "dateYesterday": "دیروز",
    "quickPriceNegotiable": "قیمت قابل مذاکره است؟",
    "quickStillAvailable": "سلام، این آگهی هنوز موجود هست؟",
    "quickVisitTime": "چه ساعتی می‌تونم برای مشاهده بیام؟",
    "quickAddress": "آدرس دقیق کجاست؟",
    "quickOnlineReserve": "امکان رزرو آنلاین هست؟",
    "loadOlder": "بارگذاری پیام‌های قدیمی‌تر…",
    "noMore": "پیام قدیمی‌تری وجود ندارد",
    "imageLabel": "تصویر",
    "inboxEmptyTitle": "هنوز گفتگویی ندارید",
    "inboxEmptyBody": "روی آگهی مورد نظر، دکمه «ارسال پیام» را بزنید.",
    "inboxLoading": "در حال بارگذاری...",
    "inboxLoadError": "خطا در بارگذاری پیام‌ها",
    "inboxSearchPlaceholder": "جستجو در گفتگوها...",
    "inboxBlocked": "مسدود",
    "adStatusActive": "فعال",
    "adStatusExpired": "منقضی",
    "adStatusPending": "در انتظار",
    "adStatusRejected": "رد شده",
    "adStatusDraft": "پیش‌نویس"
  },
  "optimus": {
    "startsWith": "شروع با",
    "contains": "شامل",
    "notContains": "بدون",
    "endsWith": "پایان با",
    "equals": "برابر",
    "notEquals": "نابرابر",
    "noFilter": "بدون فیلتر",
    "lt": "کمتر از",
    "lte": "کمتر یا مساوی",
    "gt": "بیشتر از",
    "gte": "بیشتر یا مساوی",
    "is": "برابر است با",
    "isNot": "برابر نیست با",
    "before": "قبل از",
    "after": "بعد از",
    "dateIs": "برابر است با",
    "dateIsNot": "برابر نیست با",
    "dateBefore": "قبل از تاریخ",
    "dateAfter": "بعد از تاریخ",
    "clear": "پاک کردن",
    "apply": "اعمال",
    "matchAll": "مطابقت با همه",
    "matchAny": "مطابقت با هر یک",
    "addRule": "افزودن قانون",
    "removeRule": "حذف قانون",
    "accept": "بله",
    "reject": "خیر",
    "choose": "انتخاب",
    "upload": "بارگذاری",
    "cancel": "لغو",
    "completed": "تکمیل شده",
    "fileSizeTypes": [
      "B",
      "KB",
      "MB",
      "GB",
      "TB"
    ],
    "dayNames": [
      "یکشنبه",
      "دوشنبه",
      "سه‌شنبه",
      "چهارشنبه",
      "پنجشنبه",
      "جمعه",
      "شنبه"
    ],
    "dayNamesShort": [
      "ی",
      "د",
      "س",
      "چ",
      "پ",
      "ج",
      "ش"
    ],
    "dayNamesMin": [
      "ی",
      "د",
      "س",
      "چ",
      "پ",
      "ج",
      "ش"
    ],
    "monthNames": [
      "ژانویه",
      "فوریه",
      "مارس",
      "آوریل",
      "مه",
      "ژوئن",
      "ژوئیه",
      "اوت",
      "سپتامبر",
      "اکتبر",
      "نوامبر",
      "دسامبر"
    ],
    "monthNamesShort": [
      "ژانویه",
      "فوریه",
      "مارس",
      "آوریل",
      "مه",
      "ژوئن",
      "ژوئیه",
      "اوت",
      "سپتامبر",
      "اکتبر",
      "نوامبر",
      "دسامبر"
    ],
    "dateFormat": "yy/mm/dd",
    "firstDayOfWeek": 6,
    "today": "امروز",
    "weekHeader": "هفته",
    "weak": "ضعیف",
    "medium": "متوسط",
    "strong": "قوی",
    "passwordPrompt": "رمز عبور را وارد کنید",
    "emptyMessage": "نتیجه‌ای یافت نشد",
    "emptyFilterMessage": "نتیجه‌ای یافت نشد",
    "emptySearchMessage": "نتیجه‌ای یافت نشد",
    "emptySelectionMessage": "موردی انتخاب نشده است",
    "selectionMessage": "{0} مورد انتخاب شده است",
    "searchMessage": "{0} نتیجه در دسترس است",
    "fileChosenMessage": "{0} فایل انتخاب شده است",
    "noFileChosenMessage": "هیچ فایلی انتخاب نشده است",
    "pending": "در انتظار",
    "chooseYear": "انتخاب سال",
    "chooseMonth": "انتخاب ماه",
    "chooseDate": "انتخاب تاریخ",
    "prevDecade": "دهه قبل",
    "nextDecade": "دهه بعد",
    "prevYear": "سال قبل",
    "nextYear": "سال بعد",
    "prevMonth": "ماه قبل",
    "nextMonth": "ماه بعد",
    "prevHour": "ساعت قبل",
    "nextHour": "ساعت بعد",
    "prevMinute": "دقیقه قبل",
    "nextMinute": "دقیقه بعد",
    "prevSecond": "ثانیه قبل",
    "nextSecond": "ثانیه بعد",
    "am": "ق.ظ",
    "pm": "ب.ظ",
    "aria": {
      "trueLabel": "بله",
      "falseLabel": "خیر",
      "nullLabel": "انتخاب نشده",
      "star": "{star} ستاره",
      "stars": "{star} ستاره",
      "selectAll": "انتخاب همه",
      "unselectAll": "لغو انتخاب همه",
      "close": "بستن",
      "previous": "قبلی",
      "next": "بعدی",
      "navigation": "ناوبری",
      "scrollTop": "رفتن به بالای صفحه",
      "moveTop": "انتقال به ابتدا",
      "moveUp": "انتقال به بالا",
      "moveDown": "انتقال به پایین",
      "moveBottom": "انتقال به انتها",
      "moveToTarget": "انتقال به مقصد",
      "moveToSource": "انتقال به مبدأ",
      "moveAllToTarget": "انتقال همه به مقصد",
      "moveAllToSource": "انتقال همه به مبدأ",
      "pageLabel": "صفحه {page}",
      "firstPageLabel": "صفحه اول",
      "lastPageLabel": "صفحه آخر",
      "nextPageLabel": "صفحه بعدی",
      "prevPageLabel": "صفحه قبل",
      "previousPageLabel": "صفحه قبل",
      "rowsPerPageLabel": "تعداد ردیف در هر صفحه",
      "jumpToPageDropdownLabel": "پرش به صفحه",
      "jumpToPageInputLabel": "پرش به صفحه",
      "selectRow": "انتخاب ردیف",
      "unselectRow": "لغو انتخاب ردیف",
      "expandRow": "باز کردن ردیف",
      "collapseRow": "بستن ردیف",
      "showFilterMenu": "نمایش منوی فیلتر",
      "hideFilterMenu": "پنهان کردن منوی فیلتر",
      "filterOperator": "عملگر فیلتر",
      "filterConstraint": "شرط فیلتر",
      "editRow": "ویرایش ردیف",
      "saveEdit": "ذخیره ویرایش",
      "cancelEdit": "لغو ویرایش",
      "listView": "نمای فهرستی",
      "gridView": "نمای شبکه‌ای",
      "slide": "اسلاید",
      "slideNumber": "اسلاید {slideNumber}",
      "zoomImage": "بزرگ‌نمایی تصویر",
      "zoomIn": "بزرگ‌نمایی",
      "zoomOut": "کوچک‌نمایی",
      "rotateRight": "چرخش به راست",
      "rotateLeft": "چرخش به چپ",
      "listLabel": "فهرست گزینه‌ها",
      "selectColor": "انتخاب رنگ",
      "removeLabel": "حذف",
      "browseFiles": "مرور فایل‌ها",
      "maximizeLabel": "بیشینه کردن",
      "minimizeLabel": "کمینه کردن"
    }
  }
}
